import React from 'react';
import { AdminLayout } from '../components/AdminLayout';
import TechnologyManager from '../components/AdminForms/Project/TechnologyManager';

const ManageTechnologyPage: React.FC = () => {
    return (
        <AdminLayout title="Technologies">
            <TechnologyManager />
        </AdminLayout>
    );
};

export default ManageTechnologyPage;
